import { render, staticRenderFns } from "./DestinationForm.vue?vue&type=template&id=93d41728&"
import script from "./DestinationForm.vue?vue&type=script&lang=js&"
export * from "./DestinationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DestinationForm.vue"
export default component.exports